module.exports = __webpack_public_path__ + "static/img/14010010.b0c9c0de.png";